import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useToggle } from 'utils/hooks/useToggle';
import fakeImg from 'assets/images/fake-img-unit.png';

import UnitDescriptionModal from '../UnitDescriptionModal';

const UnitCard = ({ unit }) => {
  const { t } = useTranslation();
  const { number, name, description } = unit;

  const [displayUnitDescription, setDisplayUnitDescription] = useToggle();

  return (
    <>
      <button type="button" className="unit-card" onClick={setDisplayUnitDescription}>
        <div className="unit-card__img">
          <img src={fakeImg} alt="woman" />
        </div>
        <div className="unit-card__title">
          <h3>
            {t('evieApp.programInfo.unit')} {number}
          </h3>
          <p>{name}</p>
        </div>
      </button>
      {displayUnitDescription && (
        <UnitDescriptionModal
          modalIsOpen={displayUnitDescription}
          toggleModal={setDisplayUnitDescription}
          name={name}
          description={description}
        />
      )}
    </>
  );
};

UnitCard.propTypes = {
  unit: PropTypes.shape({
    number: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default UnitCard;
